import React, { useState } from "react";
import { Link } from "react-router-dom";

const formatAppointmentTimestamp = (timestamp) => {
  if (timestamp && timestamp.toDate) {
    return timestamp.toDate().toLocaleString([], {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
  return "N/A";
};

const UpcomingAppointments = ({ appointments }) => {
  const [showAll, setShowAll] = useState(false);

  if (!appointments || appointments.length === 0) {
    return (
      <div className="rounded-2xl bg-slate-50 p-4 text-center">
        <p className="text-sm text-slate-500">
          No upcoming appointments to display.
        </p>
        <Link
          to="/appointments"
          className="mt-3 inline-block text-sm font-semibold text-blue-600 hover:text-blue-700"
        >
          Go to Appointments →
        </Link>
      </div>
    );
  }

  const visibleAppointments = showAll ? appointments : appointments.slice(0, 2);
  const hasMore = appointments.length > 2;

  return (
    <div>
      <ul className="space-y-3">
        {visibleAppointments.map((appointment) => (
          <li
            key={appointment.id}
            className="rounded-2xl border border-blue-100 bg-blue-50/70 p-4"
          >
            <p className="font-semibold text-slate-950">
              {appointment.reason} with {appointment.doctorName}
            </p>
            <p className="mt-1 text-sm text-slate-500">
              {formatAppointmentTimestamp(appointment.dateTime)}
            </p>
          </li>
        ))}
      </ul>
      <div className="mt-4 flex items-center justify-between gap-3">
        {hasMore ? (
          <button
            onClick={() => setShowAll(!showAll)}
            className="text-sm font-semibold text-blue-600 hover:text-blue-700"
          >
            {showAll ? "Show Less" : `View All (${appointments.length}) →`}
          </button>
        ) : (
          <div /> /* Spacer */
        )}
        <Link
          to="/appointments"
          className="text-sm font-semibold text-blue-600 hover:text-blue-700"
        >
          Go to Appointments →
        </Link>
      </div>
    </div>
  );
};

export default UpcomingAppointments;
